import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AutorizacaoAdminGuard implements CanActivate {
  constructor(private readonly router: Router) {
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    const usuario = JSON.parse(window.localStorage.getItem('usuario'));
    if (usuario.roles[0].nome === 'ROLE_ADMIN') {
      return true;
    } else {
      usuario.roles[0].nome === 'ROLE_MASTER' ? this.router.navigate(['master']) : this.router.navigate(['user']);
      return false;
    }
  }
}
